/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { forwardRef } from "react";

import { css, cx } from "@panda/css";
import { Box } from "@panda/jsx";

import type { ComponentProps } from "react";

const cardContentStyles = css({
	width: "100%",
});

export type CosmosCardContentProps = ComponentProps<typeof Box> & {
	className?: string;
	children: React.ReactNode;
};

export const CosmosCardContent = forwardRef(
	(
		{ className = "", children, ...props }: CosmosCardContentProps,
		forwardedRef: React.Ref<HTMLDivElement>,
	): React.JSX.Element => {
		return (
			<Box {...props} className={cx("cosmos-card__content", cardContentStyles, className)} ref={forwardedRef}>
				{children}
			</Box>
		);
	},
);

CosmosCardContent.displayName = "CosmosCard.Content";
